export interface IGifRendition {
  url?: string;
}

export interface IGif {
  images?: {
    downsized?: IGifRendition;
    downsized_medium?: IGifRendition;
    fixed_height?: IGifRendition;
    original?: IGifRendition;
    preview_gif?: IGifRendition;
  };
  id: string;
  title: string;
}

const GIF_RENDITIONS = ['downsized', 'fixed_height', 'original', 'downsized_medium', 'preview_gif'] as const;

/** First playable Giphy URL. Trending items sometimes omit downsized. */
export function gifImageUrl(gif: IGif | null | undefined): string {
  const images = gif?.images;
  if (!images) {
    return '';
  }
  for (const key of GIF_RENDITIONS) {
    const url = images[key]?.url?.trim();
    if (url) {
      return url;
    }
  }
  return '';
}
